/**
 * Получить имя иконки из пути
 * @param {string} path путь до иконки
 * @return {string} ./facilities/bathroom.svg -> bathroom
 */
const getIconName = (path) => {
  const iconNameRegExp = /[ \w-]+?(?=\.)/g;
  return iconNameRegExp.exec(path)[0];
};

/**
 * Возвращает объект с иконками
 * @return {object} { iconName: svg, }
 */
const getIcons = () => {
  const icons = {};

  const context = require.context('../icons', true, /.*\.svg$/);

  context.keys().forEach((path) => {
    const name = getIconName(path);
    icons[name] = context(path);
  });

  return icons;
};
export { getIconName, getIcons };
